import * as React from 'react';
import ViewHeaderBar from '../components/ViewHeaderBar';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import TableBody from '@material-ui/core/TableBody';
import Paper from '@material-ui/core/Paper';
import CircularProgress from '@material-ui/core/CircularProgress';
import { localizations } from '../localization/localization';
import Delete from '@material-ui/icons/Delete'
import { ApplicationState } from '../store';
import * as Store from './store/restrictionsStore'
import { connect } from 'react-redux';
import AddRestrictionDialog from './forms/AddRestrictionDialog';

type RestrictionsProps = Store.RestrictionsState & typeof Store.actionCreators;

class VisibilityRestrictions extends React.Component<RestrictionsProps> {
    constructor(props: RestrictionsProps) {
        super(props);
    }

    public componentDidMount() {
        this.props.requestRestrictions();
    }

    public render() {
        const { data, isLoading, addingNew } = this.props;
        const restrictedIds = data.map(item => item.id);

        return (
            <React.Fragment>
                <Grid container direction="column">
                    <Grid item>
                        <ViewHeaderBar titleVariant="h6" title={localizations.settings.visibilityRestrictionsTitle}>
                            <Button variant="outlined" color="primary" onClick={() => this.props.addRestriction()}>{localizations.settings.addVisibilityRestriction}</Button>
                        </ViewHeaderBar>
                    </Grid>
                    <Grid item>
                        <Paper>
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell>{localizations.common.companyName}</TableCell>
                                        <TableCell>{localizations.common.businessId}</TableCell>
                                        <TableCell>{localizations.common.city}</TableCell>
                                        <TableCell />
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {isLoading ? <TableRow><TableCell><CircularProgress /></TableCell></TableRow> :
                                        data.map((item) =>
                                            <TableRow key={item.id}>
                                                <TableCell>{item.name}</TableCell>
                                                <TableCell>{item.businessId}</TableCell>
                                                <TableCell>{item.city}</TableCell>
                                                <TableCell align="right">
                                                    <Button
                                                        color="primary"
                                                        variant="outlined"
                                                        onClick={() => this.props.deleteRestriction(item.id)}
                                                    >
                                                        <Delete color="primary" />{localizations.settings.deleteRestriction}
                                                    </Button>
                                                </TableCell>
                                            </TableRow>
                                        )}
                                </TableBody>
                            </Table>
                        </Paper>
                    </Grid>
                </Grid>

                {addingNew ? (
                    <AddRestrictionDialog
                        isOpen={addingNew}
                        restricted={restrictedIds}
                        onSubmit={this.props.addSubmitted}
                        onCancel={this.props.addCancelled}
                    />
                ): null}

            </React.Fragment>
        );
    }
}

const mapStateToProps = (state: ApplicationState) => state.restrictions;

export default connect(mapStateToProps, Store.actionCreators)(VisibilityRestrictions);


// WEBPACK FOOTER //
// ./src/account/VisibilityRestrictions.tsx